import { createAsyncThunk } from '@reduxjs/toolkit';
import concat from 'lodash/concat';
import cloneDeep from 'lodash/cloneDeep';
import remove from 'lodash/remove';

import { showLoading, hideLoading } from '../app';
import WebAPIClient, { errorResponseToastr } from '../../api';
import { SOLAR_APP_ID } from '.';
import { toastr } from '../../components/CustomToast';

const postSolarMembership = createAsyncThunk(
  'solar/postSolarMembership',
  async (newMembership, { dispatch, getState }) => {
    const stateMemberships = getState().solar.memberships;
    const stateUsers = getState().solar.users;
    let memberships = cloneDeep(stateMemberships);
    let users = cloneDeep(stateUsers);
    try {
      dispatch(showLoading());
      const { membership, user } = await new WebAPIClient(SOLAR_APP_ID).POST(
        '/resource/memberships',
        newMembership
      );
      remove(users, { user_id: user.user_id });
      memberships = concat(memberships, membership);
      users = concat(users, user);
      toastr.success({ title: 'Membership created' });
      return { memberships, users };
    } catch (err) {
      errorResponseToastr(err);
    } finally {
      dispatch(hideLoading());
    }
  }
);

const putSolarMembership = createAsyncThunk(
  'solar/putSolarMembership',
  async (updatedMembership, { dispatch, getState }) => {
    const stateMemberships = getState().solar.memberships;
    let memberships = cloneDeep(stateMemberships);
    try {
      dispatch(showLoading());
      const membership = await new WebAPIClient(SOLAR_APP_ID).PUT(
        `/resource/memberships/${updatedMembership.org_id}/${updatedMembership.user_id}`,
        updatedMembership
      );

      remove(memberships, {
        org_id: membership.org_id,
        user_id: membership.user_id,
      });
      memberships = concat(memberships, membership);

      toastr.success({ title: 'Membership updated' });
      return { memberships };
    } catch (err) {
      errorResponseToastr(err);
    } finally {
      dispatch(hideLoading());
    }
  }
);

const deleteSolarMembership = createAsyncThunk(
  'solar/deleteSolarMembership',
  async (deletedMembership, { dispatch, getState }) => {
    const stateMemberships = getState().solar.memberships;
    const stateUsers = getState().solar.users;
    let memberships = cloneDeep(stateMemberships);
    let users = cloneDeep(stateUsers);
    try {
      dispatch(showLoading());
      const user = await new WebAPIClient(SOLAR_APP_ID).DELETE(
        `/resource/memberships/${deletedMembership.org_id}/${deletedMembership.user_id}`
      );

      remove(memberships, {
        org_id: deletedMembership.org_id,
        user_id: deletedMembership.user_id,
      });
      remove(users, { user_id: user.user_id });
      users = concat(users, user);

      toastr.success({ title: 'Membership deleted' });
      return { memberships, users };
    } catch (err) {
      errorResponseToastr(err);
    } finally {
      dispatch(hideLoading());
    }
  }
);

export { postSolarMembership, putSolarMembership, deleteSolarMembership };
